export default "__VITE_ASSET__c6Y9dNRM__"